import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserCards } from 'src/app/common/interfaces';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-credit-card',
  templateUrl: `${environment.pageFolder}/credit-card.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/credit-card.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class CreditCardComponent { 
  @Input() card!: UserCards;
  @Input() userCardClass = '';
}